/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseAttachmentLinkDTO interface.
 */
export function instanceOfWarehouseCaseAttachmentLinkDTO(value) {
    return true;
}
export function WarehouseCaseAttachmentLinkDTOFromJSON(json) {
    return WarehouseCaseAttachmentLinkDTOFromJSONTyped(json, false);
}
export function WarehouseCaseAttachmentLinkDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'] == null ? undefined : json['url'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}
export function WarehouseCaseAttachmentLinkDTOToJSON(json) {
    return WarehouseCaseAttachmentLinkDTOToJSONTyped(json, false);
}
export function WarehouseCaseAttachmentLinkDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
    };
}
